import { memo } from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { MapAsset } from '@atom/types/map';
import { getColorFromColorId } from '@atom/utilities/colorUtilities';

import { getGoogleShapeCenter } from '../mapUtilities';

import AssetGroupMarkerContent from './AssetGroupMarkerContent';
import LineStringMarker from './LineStringMarker';
import {
  lineStringPath,
  MARKER_STYLE,
  resolveAnchor,
  resolveOpacity,
  resolveZIndex,
} from './markerUtilities';

type AssetGroupMarkerProps = {
  group: MapAsset[];
  isActive: boolean;
  allDisabled: boolean;
  stackKey: string;
  onAssetGroupClick: (stackKey: string) => void;
};

const AssetGroupMarker = ({
  group,
  isActive,
  allDisabled,
  stackKey,
  onAssetGroupClick,
}: AssetGroupMarkerProps) => {
  const position = getGoogleShapeCenter(group[0].location);
  const path = lineStringPath(group[0].location);
  const color = getColorFromColorId(group[0].markerId);

  const handleClick = () => {
    if (!allDisabled) {
      onAssetGroupClick(stackKey);
    }
  };

  return (
    <>
      {path && (
        <LineStringMarker
          path={path}
          color={color}
          isActive={isActive}
          onClick={handleClick}
        />
      )}
      <AdvancedMarker
        position={position}
        zIndex={resolveZIndex('asset', isActive)}
        {...resolveAnchor('assetGroup', isActive)}
        style={{ ...MARKER_STYLE, opacity: resolveOpacity(allDisabled) }}
        onClick={handleClick}
      >
        <AssetGroupMarkerContent
          count={group.length}
          color={color}
          isActive={isActive}
        />
      </AdvancedMarker>
    </>
  );
};

export default memo(AssetGroupMarker);
